import { CustomBusiness } from '@/models/custom-business.model';
import { APP } from '@/constants/app.constant';
import { handleResponseWithPagination } from '@/helpers';
import { CustomPageable } from '@/models/custom-pageable.model';
import { CustomResponse } from '@/models/custom-response.model';
import { CustomTableParams } from '@/models/custom-table-params.model';
import axios from 'axios';

export const BusinessService = {
    list,
    publicList,
    remove,
    get,
    publicGet,
    update,
    approve,
    resendConfirmation,
    getCities,
};

function remove(id: number): Promise<CustomResponse<any>> {
    return axios.delete(`${APP.API_URL}/businesses/${id}`)
        .then(handleResponse);
}

function get(id: number): Promise<CustomResponse<CustomBusiness>> {
    return axios.get(`${APP.API_URL}/businesses/${id}`)
        .then(handleResponse)
        .then((response: CustomResponse<CustomBusiness>) => {
            response.data = new CustomBusiness(response.data);
            return response;
        })
        .catch((error: any) => {
            throw error.response && error.response.data;
        });
}

function publicGet(slug: string): Promise<CustomResponse<CustomBusiness>> {
    return axios.get(`${APP.API_URL}/businesses/get/${slug}`)
        .then(handleResponse)
        .then((response: CustomResponse<CustomBusiness>) => {
            response.data = new CustomBusiness(response.data);
            return response;
        })
        .catch((error: any) => {
            throw error.response && error.response.data;
        });
}

function update(business: CustomBusiness): Promise<CustomResponse<CustomBusiness>> {
    return axios.patch(`${APP.API_URL}/businesses/${business.id}`, business)
        .then(handleResponse)
        .then((response: CustomResponse<CustomBusiness>) => {
            response.data = new CustomBusiness(response.data);
            return response;
        })
        .catch((error: any) => {
            throw error.response && error.response.data;
        });
}

function list(params?: CustomTableParams): Promise<CustomResponse<CustomPageable>> {

    return axios.get(
        `${APP.API_URL}/businesses`,
        { params },
    )
        .then(handleResponse)
        .then(handleResponseWithPagination)
        .then((response: CustomResponse<CustomPageable>) => {

            const businesses: CustomBusiness[] = response.data.content.map((business: any) => {
                return new CustomBusiness(business);
            });

            response.data.content = businesses;

            return response;
        })
        .catch((error: any) => {
            throw error.response && error.response.data;
        });
}

function publicList(params?: CustomTableParams): Promise<CustomResponse<CustomPageable>> {

    return axios.get(
        `${APP.API_URL}/businesses/list`,
        { params },
    )
        .then(handleResponse)
        .then(handleResponseWithPagination)
        .then((response: CustomResponse<CustomPageable>) => {

            const businesses: CustomBusiness[] = response.data.content.map((business: any) => {
                return new CustomBusiness(business);
            });

            response.data.content = businesses;

            return response;
        })
        .catch((error: any) => {
            throw error.response && error.response.data;
        });
}

function getCities(params?: CustomTableParams): Promise<CustomResponse<any>> {

    return axios.get(
        `${APP.API_URL}/businesses/cities`,
        { params },
    )
        .then(handleResponse)
        .then((response: CustomResponse<any>) => {
            const cities: string[] = response.data.map((city: any) => {
                return city.city;
            });
            response.data = cities;

            return response;
        })
        .catch((error: any) => {
            throw error.response && error.response.data;
        });
}

function approve(id: number, approved: boolean) {
    return axios.post(`${APP.API_URL}/businesses/${id}/approve`, { approved })
        .then(handleResponse)
        .then((response: CustomResponse<CustomBusiness>) => {
            response.data = new CustomBusiness(response.data);
            return response;
        })
        .catch((error: any) => {
            throw error.response && error.response.data;
        });
}

function resendConfirmation(id: number): Promise<CustomResponse<any>> {
    return axios.post(`${APP.API_URL}/businesses/resend-confirmation`, {
        id,
    })
        .then(handleResponse)
        .catch((error: any) => {
            throw error.response && error.response.data;
        });
}

function handleResponse(response: any): CustomResponse<any> {
    return response.data;
}

